import { render } from "./EventDetailPopup.vue?vue&type=template&id=5b0c84c0&scoped=true&ts=true"
import script from "./EventDetailPopup.vue?vue&type=script&lang=ts"
export * from "./EventDetailPopup.vue?vue&type=script&lang=ts"

import "./EventDetailPopup.vue?vue&type=style&index=0&id=5b0c84c0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0c84c0"]])

export default __exports__